var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Link } from '../../Link';
var StyledBrand = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  & a {\n    width: 100%;\n  }\n  & img {\n    padding: 0.75rem;\n    filter: grayscale(100%);\n    width: 100%;\n    display: block;\n  }\n\n  & img:hover {\n    filter: grayscale(0%);\n  }\n"], ["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  & a {\n    width: 100%;\n  }\n  & img {\n    padding: 0.75rem;\n    filter: grayscale(100%);\n    width: 100%;\n    display: block;\n  }\n\n  & img:hover {\n    filter: grayscale(0%);\n  }\n"])));
var BrandItem = function (_a) {
    var image = _a.image, url = _a.url, name = _a.name;
    return (React.createElement(Link, { to: url },
        React.createElement(StyledBrand, null,
            React.createElement("img", { src: image, alt: name }))));
};
export default BrandItem;
var templateObject_1;
//# sourceMappingURL=index.js.map